export const COMMON_COLORS = {
  TEXT_NORMAL: '#404F6B',
  EDITOR: '#21304d',
};

export const RUN_TABLE_STATUS_COLORS = {
  sleeping: '#0b95de',
  performing: '#0b95de',
  stopped: '#ec7930',
  failed: '#D23C53',
  finished: '#0EAA58',
};

export const VISUALS_STATUS_COLORS = {
  validated: '#0EAA58',
  refused: '#D23C53',
  canceled: '#AFBBC4',
};
